export default function () {
  const widgetName = 'subPageFooterImages';
  const widgetOpts = subPageFooterImagesOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 3,
    itemsPerPanel: 3,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [],
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    textOverImage: false,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      const widgetCount = widgetData.length;

      if (widgetCount <= 0) {
        $('.kings-fair-footer .inner-container').addClass('center-content-ml');
        $(`#${widgetName}`).remove();
      } else {
        createPolaroidImages(widgetData);
      }
    },
  });

  function createPolaroidImages(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let $footerLogo = $(this);

      $footerLogo
        .removeAttr('target')
        .attr({ 'aria-label': widgetData[x].Title, title: widgetData[x].Title })
        .find('.card-content')
        .remove();
    });
  }
}
